import React from 'react'
import { Helmet } from 'react-helmet'
import { TableProvider, LayoutProvider, Layout, LayoutBody, LayoutContent } from 'components'
import SegmentsContent from '../SegmentsContent'

const SegmentsPage = (): React.ReactElement => (
  <LayoutProvider
    stateKey="segments"
    initialProps={{
      sidebar: { open: false, width: 0 },
      primaryPanel: { open: false, width: 752 },
      secondaryPanel: { open: false, width: 375 },
    }}
  >
    <Helmet>
      <title>reOS | Segments</title>
    </Helmet>
    <Layout>
      <LayoutBody>
        <LayoutContent>
          <TableProvider>
            <SegmentsContent />
          </TableProvider>
        </LayoutContent>
      </LayoutBody>
    </Layout>
  </LayoutProvider>
)

export default SegmentsPage
